import { useRef, useState } from "react";
import {
    infUnidTranspInterface,
    SelectObjectRemoveInterface
} from "../../../../interfaces";
import { formatMoeda, getUuidV4, goToFocus } from "../../../../utils/utils";
import {
    ButtonRemover, ButtonTrash, ButtonVisualizar, JRow, JTable, JTBody, JTHead, SpanIcon
} from "../../../../components/Components";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxes, faDoorClosed, faPlus, faTags, faTruck } from "@fortawesome/free-solid-svg-icons";
import { TypeUnidadeTransporte } from "../../../../lists";
import { useQuestion } from "../../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../../components/ModalMessage/useModalMessage";
import { RE56 } from "../../../../utils/regex";
import NFesUnidadeTranspInfLacreCarga from "./NFesUnidadeTranspInfLacreCarga";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../app/store";
import {
    addUnidadeTransporteNFe, removeUnidadeTransporteNFe, removeUnidadeTransporteNFeTodos
} from "../../../../features/manifestoSlice";
import NFesUnidadeTranspUnidadeCarga from "./NFesUnidadeTranspUnidadeCarga";


interface formProps {
    id: number | string;
    show: boolean;
    handleClose: () => void;
}

const initialForm: infUnidTranspInterface = {
    id: 0,
    idunidtransp: '',
    qtdrat: 0,
    tpunidtransp: 1,
    lacUnidTransp: [],
    infUnidCarga: []
}

const NFesUnidadeTransp: React.FC<formProps> = ({ id, show, handleClose }) => {
    const dispatch = useDispatch();
    const [form, setForm] = useState<infUnidTranspInterface>(initialForm);
    const [idUnidadeTransporte, setIdUnidadeTransporte] = useState<number | string>(0);
    const [showLacres, setShowLacres] = useState<boolean>(false);
    const [showCargas, setShowCargas] = useState<boolean>(false);
    const idunidtranspRef = useRef<HTMLInputElement>(null)
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [selecionado, setSelecionado] = useState<number | string>('');
    const unidadesTransporteNFe = useSelector((state: RootState) => state.manifesto.manifesto).infMunDescarga
        .flatMap(item => item.infNFe)
        .filter(nfe => nfe?.id?.toString() === id.toString())
        .flatMap(item => item?.infUnidTransp);

    const handleCloseLacres = () => {
        setShowLacres(false);
        setSelecionado('');
    }

    const handleCloseCargas = () => {
        setShowCargas(false);
        setSelecionado('');
    }

    const handleEditarLacres = (id: number | string) => {
        setIdUnidadeTransporte(id);
        setSelecionado(id);
        setShowLacres(true);
    }

    const handleEditarUnidadeCarga = (id: number | string) => {
        setIdUnidadeTransporte(id);
        setShowCargas(true);
        setSelecionado(id);
    }

    const validaPreenchimento = () => {
        if (form.idunidtransp.trim() === "") {
            alertModal('Informe o Identificador da unidade de transporte.');
            goToFocus(idunidtranspRef);
            return false;
        }

        if (unidadesTransporteNFe
            .find(item => item?.idunidtransp.toString() === form.idunidtransp.toString() &&
                item.tpunidtransp.toString() === form.tpunidtransp.toString())) {
            alertModal('Identificador com o tipo informado já adicionado.');
            goToFocus(idunidtranspRef);
            return false;
        }
        return true;
    }

    const handleChange = (e: any) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addUnidadeTransporteNFe({
                nfeId: id,
                data: {
                    ...form,
                    id: getUuidV4()
                }
            }))
            setForm(initialForm);
            goToFocus(idunidtranspRef);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        if (unidadesTransporteNFe?.length > 0) {
            setSelecionado(value.id);
            
            const confirmed = await confirm({
                message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeUnidadeTransporteNFe({
                    id: value.id,
                    nfeId: id
                }))
            }
            setSelecionado('');
        }
    }

    const handleRemoverTudo = async () => {
        if (unidadesTransporteNFe?.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todas as unidades de transporte ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeUnidadeTransporteNFeTodos({
                    nfeId: id
                }))
            }
        }
    }

    return (<>
        <Modal show={show} onHide={handleClose}
            centered backdrop='static' size="xl" fullscreen={'xl-down'} scrollable>
            <Modal.Header closeButton className="py-2 ">
                <Modal.Title>
                    <FontAwesomeIcon icon={faTruck} className="me-1" />
                    Unidades de Transporte
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <JRow className="mb-3">
                    <Col md>
                        <Form.Group controlId="nfe-tpunidtransp">
                            <Form.Label>Tipo Unid. Transp.</Form.Label>
                            <Form.Select name="tpunidtransp" onChange={handleChange}
                                value={form.tpunidtransp}>
                                {TypeUnidadeTransporte.map(x => (
                                    <option key={x.id} value={x.id}>{x.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="nfe-idunidtransp">
                            <Form.Label>* Identificação</Form.Label>
                            <Form.Control type="text" name="idunidtransp" maxLength={20}
                                value={form.idunidtransp}
                                ref={idunidtranspRef}
                                onChange={(e) => {
                                    setForm({
                                        ...form,
                                        [e.target.name]: e.target.value.replace(RE56, '')
                                    })
                                }} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="nfe-qtdrat">
                            <Form.Label>Rateio</Form.Label>
                            <Form.Control type="number" name="qtdrat" min={0} value={form.qtdrat}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex align-items-end">
                        <Button variant="primary" onClick={handleAdd} >
                            <FontAwesomeIcon icon={faPlus} /> Adicionar
                        </Button>
                    </Col>

                </JRow>

                <JTable>
                    <JTHead >
                        <tr>
                            <th className="text-center" style={{ width: '2.5rem' }}>
                                <ButtonTrash onClick={() => handleRemoverTudo()} />
                            </th>
                            <th>Tipo Unid. Carga</th>
                            <th>Identificador</th>
                            <th>Qtd. Rateio</th>
                            <th style={{ width: '5rem' }} className="text-center">Lacres</th>
                            <th style={{ width: '5rem' }} className="text-center">Cargas</th>

                        </tr>
                    </JTHead>
                    <JTBody>
                        {unidadesTransporteNFe?.map((item: any) => {
                            return (
                                <tr key={item.id} 
                                    className={(item.id?.toString()) === selecionado.toString() ? 'table-danger' : ''}>
                                    <td className="text-center d-flex justify-content-around">
                                        <ButtonRemover onClick={() =>
                                            handleRemover({ id: item.id, title: item.idunidtransp })
                                        } />

                                    </td>
                                    <td>
                                        {TypeUnidadeTransporte.find((i) => (
                                            i.id.toString() === item.tpunidtransp.toString()
                                        ))?.name
                                        }
                                    </td>
                                    <td>{item.idunidtransp}</td>
                                    <td>{formatMoeda(item.qtdrat, 3, "decimal")}</td>
                                    <td className="text-center">
                                        <ButtonVisualizar icon={faTags} onClick={() => handleEditarLacres(item.id)} title="Lacres">
                                            <SpanIcon count={item?.lacUnidTransp?.length} />
                                        </ButtonVisualizar>

                                    </td>
                                    <td className="text-center">
                                        <ButtonVisualizar icon={faBoxes} onClick={() => handleEditarUnidadeCarga(item.id)}
                                            title="Unidade de Carga">
                                            <SpanIcon count={item?.infUnidCarga?.length} />
                                        </ButtonVisualizar>
                                    </td>

                                </tr>
                            )
                        })}

                    </JTBody>
                </JTable>
                {ConfirmModal}
                {ModalMessageEl}

            </Modal.Body>

            <Modal.Footer className="py-2">
                <Button variant="secondary" onClick={handleClose} >
                    <FontAwesomeIcon icon={faDoorClosed} /> Fechar
                </Button>
            </Modal.Footer>
        </Modal>

        <NFesUnidadeTranspInfLacreCarga
            show={showLacres}
            handleClose={handleCloseLacres}
            id={idUnidadeTransporte}
            idNFe={id} />

        <NFesUnidadeTranspUnidadeCarga
            show={showCargas}
            handleClose={handleCloseCargas}
            id={idUnidadeTransporte}
            idNFe={id}
        />
    </>)
}

export default NFesUnidadeTransp;